import PropTypes from 'prop-types'

import styles from './Checkbox.module.scss'

const Wrapper = ({ noLabel, children, className }) => {
  return noLabel ? (
    <div className={className}>{children}</div>
  ) : (
    <label className={className}>{children}</label>
  )
}

const Checkbox = ({ _labelText, _noLabel, ...props }) => (
  <Wrapper className={styles.container}>
    <span className={styles.label}>{props.labelText}</span>
    <input type="checkbox" {...props} />
    <div className={styles.checkbox}>
      <div className={styles.check}></div>
    </div>
  </Wrapper>
)

Checkbox.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  noLabel: PropTypes.bool
}

export default Checkbox
